import React, { useState, useCallback } from "react";
import HttpAction from "modules/utils/HttpAction";
const RecruitContext = React.createContext({
  state: { recruitList: {} },
  actions: {
    getRecruit: () => {},
  },
});

const RecruitProvider = ({ children }) => {
  const [recruitList, setRecruitList] = useState([]);
  const [recruit, setRecruit] = useState([]);
  const [recruitListInfo, setRecruitListInfo] = useState([]);
  
  const getRecruitList = useCallback((pageInfo) => {
    HttpAction({
      url:"api/member/recruit/list", 
      method: "get",
      params: {
        recruitTitle: pageInfo && pageInfo.recruitTitle,
        recruitFlg: pageInfo && pageInfo.recruitFlg,
        page: pageInfo && pageInfo.page,
        records: pageInfo && pageInfo.records,
        isInprogress : true,
      }
    }).then((res) => {
      if (res.code === 200) {
        setRecruitList(res.data);
        setRecruitListInfo(res.data)
      } else {
      }
    });
  }, []);

  const getRecruit = useCallback((recruitNoticeSn) => {
    HttpAction({
      url:"api/member/recruit", 
      method: "get",
      params: {
        recruitNoticeSn: recruitNoticeSn,
      }
    }).then((res) => {
      if (res.code === 200) {
        setRecruit(res.data.data);
      } else {
      }
    });
  }, []);

  const value = {
    state: { recruitList, recruit, recruitListInfo },
    actions: { getRecruitList, getRecruit },
  };

  return (
    <RecruitContext.Provider value={value}>
      {children}
    </RecruitContext.Provider>
  );
};

const { Consumer: RecruitConsumer } = RecruitContext;

export { RecruitProvider, RecruitConsumer, RecruitContext };

export default RecruitContext;
